import Select from "react-select";
import { compactSelectStyles } from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";
import ReportFilterSection from "./ReportFilterSection.jsx";

const TablesReportPanel = ({
  t,
  reportI18nKeys,
  eventsOptions,
  selectedEvent,
  selectedReportOption,
  loadingEvents,
  businessEventSelectProps,
  handlers,
}) => (
  <ReportFilterSection t={t} reportI18nKeys={reportI18nKeys}>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.EVENT)}</label>
      <Select
        options={eventsOptions}
        value={selectedEvent}
        onChange={handlers.onSelectEvent}
        isDisabled={!selectedReportOption}
        isLoading={loadingEvents}
        placeholder={t(reportI18nKeys.EVENT_PLACEHOLDER)}
        styles={compactSelectStyles}
        {...businessEventSelectProps}
      />
    </div>
  </ReportFilterSection>
);

export default TablesReportPanel;
